import { render } from "./special.vue?vue&type=template&id=54f21185&scoped=true"
import script from "./special.vue?vue&type=script&lang=js"
export * from "./special.vue?vue&type=script&lang=js"

import "./special.vue?vue&type=style&index=0&id=54f21185&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f21185"]])

export default __exports__